var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3203 4.96388L1.21405 8.65528C1.10248 8.68579 1.00303 8.74994 0.929236 8.83901C0.855446 8.92807 0.810906 9.03772 0.801682 9.15301C0.792459 9.26831 0.819001 9.38364 0.877692 9.4833C0.936384 9.58297 1.02437 9.66212 1.12967 9.70997L7.14842 12.5576C7.26632 12.6122 7.36101 12.7069 7.41561 12.8248L10.2633 18.8436C10.3111 18.9489 10.3903 19.0369 10.4899 19.0955C10.5896 19.1542 10.7049 19.1808 10.8202 19.1716C10.9355 19.1623 11.0452 19.1178 11.1342 19.044C11.2233 18.9702 11.2874 18.8708 11.318 18.7592L15.0094 5.65294C15.0373 5.5573 15.0391 5.45589 15.0144 5.35935C14.9897 5.26281 14.9395 5.1747 14.869 5.10423C14.7985 5.03377 14.7104 4.98356 14.6139 4.95887C14.5173 4.93417 14.4159 4.9359 14.3203 4.96388Z",
    stroke: "#D8D6D4",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03418 12.9401L14.5342 5.44006",
    stroke: "#D8D6D4",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSendIcon);
export default __webpack_public_path__ + "static/media/chat_send_icon.4989f41d171002eda0ee6eaa9cfa445c.svg";
export { ForwardRef as ReactComponent };